/* eslint-disable no-console */
import * as React from "react"; 
import { useState, useEffect } from "react";
import Modal from "../core/Modal";
import { jfetch, toast } from "../../utils";
import { ResponsiveLine } from '@nivo/line'
import { FunnelChart } from 'react-funnel-pipeline'
import 'react-funnel-pipeline/dist/index.css'
import img from '../../../assets/images/white-owl-cw.png'

function KPI(props){

  const [websiteStatus, setWebsiteStatus] = useState(null);
  const [cwStatus, setCwStatus] = useState(null)
  const [fbStatus, setFbStatus] = useState(null)
  const [acStatus, setAcStatus] = useState(null)

  const [charts, setCharts] = useState(null)
  const [cwCharts, setCwCharts] = useState(null)
  const [fbCharts, setFbCharts] = useState(null)
  const [acCharts, setAcCharts] = useState(null)

  const [title, setTitle] = useState(null)

  const [funnels, setFunnels] = useState(null)

  const icons = [
    {
      title: 'Website Value',
      icon: 'fa-solid fa-coins',
      data: 'website_value',
      type: 'website',
      is_money: true
    },
    {
      title: 'Website Traffic',
      icon: 'fa-solid fa-traffic-light',
      data: 'website_traffic',
      type: 'website',
      is_money: false
    },
    {
      title: 'Website Rank',
      icon: 'fa-solid fa-award',
      data: 'website_rank',
      type: 'website',
      is_money: false
    },
    {
      title: 'Contact List',
      icon: 'fa-solid fa-address-book',
      data: 'contacts_count',
      type: 'ac',
      is_money: false
    },
    {
      title: 'Keywords Count',
      icon: 'fa-solid fa-key',
      data: 'keywords_count',
      type: 'website',
      is_money: false
    },
    {
      title: 'Website Authority Score',
      icon: 'fa-solid fa-chess-king',
      data: 'website_ascore',
      type: 'website',
      is_money: false
    },
    {
      title: 'Backlinks',
      icon: 'fa-solid fa-link',
      data: 'backlinks_count',
      type: 'website',
      is_money: false
    },
    {
      title: 'Backlink Urls',
      icon: 'fa-solid fa-globe',
      data: 'backlinks_domains',
      type: 'website',
      is_money: false
    },
    {
      title: 'Page Impressions',
      icon: 'fa-brands fa-facebook-f',
      data: 'page_impressions_unique',
      type: 'fb',
      is_money: false
    },
    {
      title: 'Post Impressions',
      icon: 'fa-brands fa-facebook-f',
      data: 'page_posts_impressions_unique',
      type: 'fb',
      is_money: false
    },
    {
      title: 'Post Engagements',
      icon: 'fa-brands fa-facebook-f',
      data: 'page_post_engagements',
      type: 'fb',
      is_money: false
    },
    {
      title: 'Connectwise Activities',
      data: 'activities_count',
      type: 'cw',
      is_money: false
    },
    {
      title: 'Connectwise Opportunities',
      data: 'opportunities_count',
      type: 'cw',
      is_money: false
    }    
  ]

  const blue_colors = ['#4091c9', '#1368aa', '#033270']
  const green_colors = ['#29BB89', '#289672', '#1E6F5C']

  useEffect(() => {
    // get data for the icons
    jfetch.get('/semrush/data').then((resp) => {
      setWebsiteStatus(resp.status)
    })
    jfetch.get('/cw/data').then((resp) => {
      setCwStatus(resp.status)
    })
    jfetch.get('/facebook/data').then((resp) => {
      setFbStatus(resp.status)
    })
    jfetch.get('/ac/data').then((resp) => {
      setAcStatus(resp.status)
    })
  }, [])

  useEffect(() => {
    // get data for the charts
    jfetch.get(`/semrush/charts`).then((resp) => {
      setCharts(resp)
    })
    jfetch.get(`/cw/charts`).then((resp) => {
      setCwCharts(resp)
    })    
    jfetch.get(`/facebook/charts`).then((resp) => {
      setFbCharts(resp)
    })
    jfetch.get(`/ac/charts`).then((resp) => {
      setAcCharts(resp)
    })    
    jfetch.get('/global_settings/show').then((resp) => {
      setTitle(resp.setting.kpi_title)
    })
  }, [])

  useEffect(() => {
    // get data for the funnels
    jfetch.get(`/cw/funnels`).then((resp) => {
      setFunnels(resp)
    })
  }, [])

  return(
    <>
    <div className="container">
      { title && (
      <div className="row">
        <h2 className="text-center" style={{color:'#292929'}}>{title}</h2>
      </div>
      )}
    </div>

    <div className="container" style={{paddingTop:'35px'}}>
      <div className="row">
        { funnels && (
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-12">
                <h5 className="card-title" style={{color:'black'}}>ConnectWise Funnel {funnels.previous_label}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FunnelChart 
                  data={funnels.previous_month}
                  pallette={blue_colors}
                />                
              </div>
            </div>
          </div>
        )}
        { funnels && (
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-12">
                <h5 className="card-title" style={{color:'black'}}>ConnectWise Revenue {funnels.previous_label}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FunnelChart 
                  data={funnels.previous_cost}
                  pallette={green_colors}
                  showValues={false}
                />                
              </div>
            </div>
          </div>
        )}
        { funnels && (
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-12">
                <h4 style={{color:'black'}}>{funnels.previous_label} Rates</h4>
                <h4 style={{color:'black'}}>Activities to Opportunities: {funnels.previous_rate_1} %</h4>
                <h4 style={{color:'black'}}>Opportunities Won: {funnels.previous_rate_2} %</h4>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="row">        
          { funnels && (
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12">
                  <h5 className="card-title" style={{color:'black'}}>ConnectWise Funnel {funnels.current_label}</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FunnelChart 
                    data={funnels.current_month}
                    pallette={blue_colors}
                  />             
                </div>
              </div>
            </div>
          )}
          { funnels && (
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12">
                  <h5 className="card-title" style={{color:'black'}}>ConnectWise Revenue {funnels.current_label}</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FunnelChart 
                    data={funnels.current_cost}
                    pallette={green_colors}
                    showValues={false}
                  />             
                </div>
              </div>
            </div>
          )}
        
          { funnels && (
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12">
                  <h4 style={{color:'black'}}>{funnels.current_label} Rates</h4>
                  <h4 style={{color:'black'}}>Activities to Opportunities: {funnels.current_rate_1} %</h4>
                  <h4 style={{color:'black'}}>Opportunities Won: {funnels.current_rate_2} %</h4>
                </div>
              </div>
            </div>
          )}
        
      </div>
    </div>

    <div className="container" style={{paddingTop:'35px', paddingBottom:'35px', color:'#292929'}}>
      <div className="row kpi-row" style={{paddingBottom:'35px', textAlign:'center'}}>
          <>
          {icons.map((icon) => {
            switch(icon.type) {
              case 'website':
                return (
                  (websiteStatus && charts) ? <Icon data={websiteStatus[icon.data]} chart={charts[icon.data]} title={icon.title} icon={icon.icon} /> : <Error title={icon.title} icon={icon.icon} />
                )
              case 'cw':
                return (
                  (cwStatus && cwCharts) ? <Icon data={cwStatus[icon.data]} chart={cwCharts[icon.data]} title={icon.title} is_cw={true} /> : <Error title={icon.title} icon={icon.icon} is_cw={true} />
                )
              case 'ac':
                return (
                  (acStatus && acCharts) ? <Icon data={acStatus[icon.data]} chart={acCharts[icon.data]} title={icon.title} icon={icon.icon} /> : <Error title={icon.title} icon={icon.icon} />
                )
              case 'fb':
                return (
                  (fbStatus && fbCharts) ? <Icon data={fbStatus[icon.data]} chart={fbCharts[icon.data]} title={icon.title} icon={icon.icon} /> : <Error title={icon.title} icon={icon.icon} />
                )
              default: 
            }
          })}
          <div className="col-lg-3">
            <a href="/lead_safari/in_progress" target="_blank" rel="noopener noreferrer">
              <i className={`kpi-icon fa-solid fa-solid fa-compass fa-2xl`}></i>
              <p className="text-center kpi-title">Lead Safari</p>
            </a>
          </div>
          </>
      </div>
    </div>
    </>
  )}
// u
function PastModal(props){
  const [show, setShow] = useState(false)

  function passCheck(){
    if(props.chart != null){
      let a = props.chart[0]["data"].reduce((a,b) => a+b.y,0)
      // let b = websiteVal[1]["data"].reduce((a,b) => a+b.y,0)
      return (a) > 0
    }
    else{
      return false
    }
  } 

  function format_val(value, decimals){
    let is_m = props.is_money || false
    if(is_m){
      return `$ ${value.toLocaleString('en-us', {minimumFractionDigits: decimals})}`
    }
    else{
     return value
    }
  }

  return (
    <>
      <a onClick={() => setShow(true)} style={{cursor:'pointer'}}>
        {props.children}
      </a>
      <Modal
        title={props.label}
        open={show}
        close={() => setShow(false)}
        submittable={false}
        isLarge={true}
        disallowClickOutside={true}
      >
        <div className="container-fluid" style={{margin:'0px'}}>
          <div className="row">
            <div className="col-lg-12">
              <div style={{height:'450px'}}>
                { passCheck() && ( 
                  <ResponsiveLine
                    data={props.chart}
                    margin={{ top: 20, right: 130, bottom: 50, left: 70 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                    yFormat={ (value) => format_val(value, 2) }
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'months',
                        legendOffset: 36,
                        legendPosition: 'middle'
                    }}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendOffset: -60,
                        legendPosition: 'middle',
                        format: value => 
                        format_val(value, 0)
                    }}
                    colors={{ scheme: 'nivo' }}
                    pointSize={10}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    pointLabel="y"
                    pointLabelYOffset={-12}
                    useMesh={true}
                    legends={[
                      {
                          anchor: 'bottom-right',
                          direction: 'column',
                          justify: false,
                          translateX: 100,
                          translateY: 0,
                          itemsSpacing: 0,
                          itemDirection: 'left-to-right',
                          itemWidth: 80,
                          itemHeight: 20,
                          itemOpacity: 0.75,
                          symbolSize: 12,
                          symbolShape: 'circle',
                          symbolBorderColor: 'rgba(0, 0, 0, .5)',
                          effects: [
                              {
                                  on: 'hover',
                                  style: {
                                      itemBackground: 'rgba(0, 0, 0, .03)',
                                      itemOpacity: 1
                                  }
                              }
                          ]
                      }
                  ]}        
                />)}
              </div>     
            </div>
          </div>
        </div> 
      </Modal>
    </>
  )
}

function MetrivValue(props){  
  let change = props.data.change
  let color = ''
  let arrow = ''
  if(change > 0){
    color = 'forestgreen'
    arrow = 'fa fa-arrow-up'
  }
  else{
    color = 'red'
    arrow = 'fa fa-arrow-down'
  }
  return (
    <p className="text-center" style={{color: color, marginBottom:'0px', marginTop:'0px'}}>
      {props.data.value}  &nbsp; <i className={arrow}/> {Math.abs(change).toFixed(1)}% 
    </p>
  )
}

function Icon(props){
  const is_cw = props.is_cw ? props.is_cw : false
  return (
    <div className="col-lg-3" style={{paddingBottom:'35px'}}>  
      <PastModal chart={props.chart} label={props.title} is_money={props.is_money}>
        {is_cw ? (
          <img className="img-responsive kpi-icon" src={img} />
        ) : (
          <i className={`kpi-icon fa-solid ${props.icon} fa-2xl`}></i>
        )}
        <p className="text-center kpi-title">{props.title}</p>
        <MetrivValue data={props.data} />
      </PastModal>
    </div>
  )
}

function Error(props){
  const is_cw = props.is_cw ? props.is_cw : false
  return (
    <div className="col-lg-3" style={{paddingBottom:'35px'}}>  
      <PastModal chart={props.chart} label={props.title} is_money={props.is_money}>
        {is_cw ? (
          <img className="img-responsive kpi-icon" src={img} />
        ) : (
          <i className={`kpi-icon fa-solid ${props.icon} fa-2xl`}></i>
        )}
        <p className="text-center kpi-title">{props.title}</p>
        <p className="text-danger">could not retrieve data</p>
      </PastModal>
    </div>
  )  
}

export default KPI


// WEBPACK FOOTER //
// ./app/javascript/components/pages/KPI.tsx